import { Injectable } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import {
  CompanyProfile,
  CompanyProfileObject,
} from '@app/forms/subscription/definition/interface/subscription';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';
import companyForm from '@app/forms/subscription/services/companyForm';
import * as _ from 'lodash';

@Injectable({ providedIn: 'root' })
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: CompanyProfileObject): UntypedFormGroup {
    return companyForm.generatForm(entity, this.formBuilder);
  }

  generate(entity: CompanyProfile[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
    });
  }
  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }
  extract() {
    const formValue = _.cloneDeep(this.form.value.owners);
    formValue.forEach(item => {
      this.transformBeneficialOwner(item);
      this.transformAddresses(item);
    });

    return formValue;
  }
  private transformAddresses(item: any) {
    if (item?.company?.addressSiegeSocial?.country?.value) {
      item.company.addressSiegeSocial.country =
        item.company.addressSiegeSocial.country.value;
    }
    if (item?.company?.addressSiegeAdministratif?.country?.value) {
      item.company.addressSiegeAdministratif.country =
        item.company.addressSiegeAdministratif.country.value;
    }
  }

  private transformBeneficialOwner(item: any) {
    item.company.beneficialOwner.forEach(item => {
      item.address = this.transformAddress(item?.address);
    });
  }

  transformAddress(originalAddress: {
    street: string;
    street2?: string;
    zipCode: string;
    city: string;
    country: string;
  }) {
    const address = originalAddress
      ? (({ street, street2, city, zipCode, country, ...address }) => ({
          ...address,
          addressStreet: street || '',
          addressStreet2: street2 || '',
          addressCity: city || '',
          addressZipCode: zipCode || '',
          addressCountry: country || '',
        }))(originalAddress)
      : {};
    return address;
  }
}
@Injectable({ providedIn: 'root' })
export class CivilStateValidation extends EaSubscriptionBuilder {
  onSubmit() {
    throw new Error('Method not implemented.');
  }

  isValid(entity) {
    return this.generate(entity, {})?.valid;
  }
}
